import "./SelectProgramme.scss";
import React, { useEffect, useState } from "react";

import { Helmet } from "react-helmet";
import { Container } from "@material-ui/core";

import { SectionHeader, SectionHeading, SectionIntro } from "../../atoms/SectionHeader";
import HeroBanner from "../../organisms/HeroBanner";
import { smokeFreeCardData, loseWeightCardData } from "../../../data/Programme";
import ProgrammeCard from "../../molecules/ProgrammeCard";

function SelectProgramme() {
  const [programmeCardData, setProgrammeCardData] = useState();

  useEffect(() => {
    setProgrammeCardData([smokeFreeCardData, loseWeightCardData]);
  }, []);

  return (
    <div className="programme-select-page">
      <Helmet>
        <title>Select Programme | Sign up | Gloji</title>
      </Helmet>
      <HeroBanner>
        <h1 className="hero-banner__heading">Welcome to gloji</h1>
      </HeroBanner>
      <Container className="main-content__container diagonal-banner__top-neighbour programme-cards">
        <section>
          <SectionHeader>
            <SectionHeading> Change your life with gloji</SectionHeading>
            <SectionIntro>
              We’ve got a range of programmes that will help you take your health and wellbeing to the next
              level!
            </SectionIntro>
          </SectionHeader>
          <div className="programme-cards__container disabled-my-path">
            {programmeCardData &&
              programmeCardData.map(x => {
                return (
                  <ProgrammeCard
                    key={x.programmeId}
                    primaryButtonUrl={x.primaryButtonUrl}
                    primaryButtonText={x.primaryButtonText}
                    secondaryButtonUrl={x.secondaryButtonUrl}
                    programmeTitle={x.programmeTitle}
                    cardTitle={x.cardTitle}
                    imgUrl={x.imgUrl}
                    imgTitle={x.imgTitle}
                    description={x.description}
                    enablePlayIcon={x.enablePlayIcon}
                    disableViewPathButton={true}
                  />
                );
              })}
          </div>
        </section>
      </Container>
    </div>
  );
}

export default SelectProgramme;
